/**
 * Custom checkout — inline toggles (faktura VAT, notatki do zamówienia).
 *
 * Dwa typy triggerów:
 *   1. <input type="checkbox" data-hn-co-inline-trigger>  — faktura VAT
 *   2. <button data-hn-co-inline-trigger aria-expanded>   — notatka
 *
 * Pattern HTML:
 *   <div class="hn-co__inline-toggle" data-hn-co-inline-toggle>
 *     <input|button data-hn-co-inline-trigger>
 *     <div class="hn-co__inline-toggle-body"> …pola… </div>
 *   </div>
 *
 * CSS animuje rozwinięcie via `grid-template-rows: 0fr → 1fr`, wyzwalane
 * przez klasę `.is-open` na wrapperze.
 */
export function initCheckoutInlineToggles() {
    const isOpen = (trigger) => {
        if (trigger.tagName === 'INPUT') {
            return !!trigger.checked;
        }
        // Button — stan w aria-expanded.
        return trigger.getAttribute('aria-expanded') === 'true';
    };

    const setOpen = (trigger, open) => {
        const wrap = trigger.closest('[data-hn-co-inline-toggle]');
        if (!wrap) return;
        wrap.classList.toggle('is-open', !!open);
        if (trigger.tagName === 'INPUT') {
            trigger.checked = !!open;
            // Faktura: zwinięte pola są disabled (nie walidują się i nie idą w POST), rozwinięte — wymagane.
            wrap.querySelectorAll('.hn-co__inline-toggle-body input').forEach((inp) => {
                if (inp.closest('[data-hn-co-invoice-address]')) return; // adres firmy: checkout-invoice.js
                inp.disabled = !open;
                inp.required = !!open && !inp.hasAttribute('data-hn-co-optional');
            });
            wrap.dispatchEvent(new CustomEvent('hn-co-inline-toggle', { bubbles: true }));
        } else {
            trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
    };

    // Init — auto-open jeśli body ma pre-filled value (NIP z sesji, treść notatki).
    document.querySelectorAll('[data-hn-co-inline-trigger]').forEach((trigger) => {
        const wrap = trigger.closest('[data-hn-co-inline-toggle]');
        if (!wrap) return;
        let shouldOpen = false;
        wrap.querySelectorAll('.hn-co__inline-toggle-body input, .hn-co__inline-toggle-body textarea').forEach((inp) => {
            if (inp.value && inp.value.trim() !== '') {
                shouldOpen = true;
            }
        });
        setOpen(trigger, shouldOpen);
    });

    // Checkbox-style trigger (faktura) — change event.
    document.addEventListener('change', (e) => {
        const t = e.target;
        if (t && t.matches('input[data-hn-co-inline-trigger]')) {
            setOpen(t, t.checked);
        }
    });

    // Button-style trigger (notatka) — click event, toggle aria-expanded.
    document.addEventListener('click', (e) => {
        const t = e.target.closest && e.target.closest('button[data-hn-co-inline-trigger]');
        if (!t) return;
        e.preventDefault();
        setOpen(t, !isOpen(t));
    });
}
